import components from './components'
import data from './data'
import methods from './methods'
import props from './props'

export default {
  components,
  data,
  methods,
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/schedule/resources/index.js